import StateCode from './StateCode';

class DetailFormMode {
  static READ_ONLY = 'readOnly';
  static EDIT = 'edit';
  static REVIEW = 'review';
  static MODIFIABLE = 'modifiable';

  constructor(private code: string) {}

  public static create(stateCode: StateCode, canModify: boolean): DetailFormMode {
    if (stateCode.isEnCreacion() || stateCode.isPendiente()) {
      return new DetailFormMode(DetailFormMode.EDIT);
    }
    if (stateCode.isAceptada() || stateCode.isConfirmada()) {
      return new DetailFormMode(DetailFormMode.REVIEW);
    }
    if (canModify) {
      return new DetailFormMode(DetailFormMode.MODIFIABLE);
    }
    return new DetailFormMode(DetailFormMode.READ_ONLY);
  }

  public isInReadOnlyMode(): boolean {
    return this.code === DetailFormMode.READ_ONLY;
  }

  public isInEditMode(): boolean {
    return this.code === DetailFormMode.EDIT;
  }

  public isInReviewMode(): boolean {
    return this.code === DetailFormMode.REVIEW;
  }

  public isInModifiableMode(): boolean {
    return this.code === DetailFormMode.MODIFIABLE;
  }

  public value(): string {
    return this.code;
  }
}

export default DetailFormMode;
